// PROTOTYPE — deckbuilder agent. Throwaway code, see
// apps/server/app/agents/deckbuilder/NOTES.md.
import { SpinnerCentered } from 'components/Spinner'

// The spinner in the middle of whatever it loads: it fills its container
// (a flex column or a box with a height), and keeps 8rem of room where the
// container has no height of its own (a list still loading).
export function DeckbuilderLoader() {
  return (
    <div className="flex h-full min-h-32 w-full flex-1 items-center justify-center">
      <SpinnerCentered />
    </div>
  )
}
